import { render, staticRenderFns } from "./dettes.html?vue&type=template&id=8dcac356&scoped=true&external"
import script from "./dettes.js?vue&type=script&lang=js&external"
export * from "./dettes.js?vue&type=script&lang=js&external"
import style0 from "./dettes.scss?vue&type=style&index=0&id=8dcac356&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcac356",
  null
  
)

export default component.exports